import { Box } from '@chakra-ui/react';
import { FC, ReactElement } from 'react';
import AlertItem from './AlertItem';

interface Props {
  alerterItems?: IAlerterItem[],
  autoClose?: boolean,
}

const Alerter: FC<Props> = ({
  alerterItems,
}: Props): ReactElement => (
  <Box>
    {alerterItems.map((item) => <AlertItem {...item} key={item.title} />)}
  </Box>
);

export default Alerter;
